module.exports = __webpack_public_path__ + "7fd8ffd68c9b921143b28f8aa9f5bc50.png";